<template>
  <div>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-sm-12 col-md-3 col-lg-3">
              <h3 class="mb-2">Cantidades diarias</h3>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
              <base-input addon-left-icon="ni ni-calendar-grid-58" class>
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="date"
                  placeholder="Seleccione fecha"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-sm-6 col-md-12 col-lg-6">

              <base-button
                type="danger"
                :loading="loadingDownload"
                @click="downloadComands"
                :disabled="!activeDomain"
              >
                <i class="far fa-file-pdf"></i> Comandas
              </base-button>

              <base-button
                type="danger"
                :loading="loadingDownloadTheoryInventory"
                @click="downloadTheoryInventory"
                :disabled="loadingDownloadTheoryInventory"
              >
                <i class="far fa-file-pdf"></i> Salidas diarias
              </base-button>

              <base-button
                type="danger"
                @click="showModalInventory = true"
              >
                <i class="far fa-file-pdf"></i> Inventario Semana
              </base-button>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="meals"
              @selection-change="onSelectionChange"
            >
              <el-table-column
                label="Alimento"
                min-width="220px"
                prop="meal_id"
                sortable
              >
                <template v-slot="{ row }">
                  <div class="table-user">
                    <img width="50" height="50" :src="row.image_url" alt/>
                    {{ row ? row.name.toUpperCase() : "" }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Receta"
                prop="subgroup_id"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{ row }">
                  <a :href="'/#/receta/' + row.id">
                    <base-button type="success">Receta</base-button>
                  </a>
                </template>
              </el-table-column>

              <el-table-column
                label="Descargar PDF"
                prop="subgroup_id"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{ row }">
                  <base-button
                    @click="
                          downloadComandsMeals(
                              date,
                              user.catering_id,
                              row.id
                          )
                      "
                    type="danger"
                    :disabled="!activeDomain"
                  >
                    <i class="far fa-file-pdf"></i> Descargar
                  </base-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <br /> -->
            <div class="item-recipe row">
              <div class="content">
                <div class="img">
                  <img
                    src="https://d1u6ma1fmhichy.cloudfront.net/storage/images/AkGZxdZw6Y.jpeg"
                    alt=""
                  />
                </div>
                <div class="title-recipe">Snacks, ensaladas y adicionales</div>
              </div>
              <div class="main">
                <base-button
                  type="danger"
                  :loading="loadingDownloadSnacks"
                  @click="downloadComandsSnacks"
                  :disabled="!activeDomain"
                >
                  <i class="far fa-file-pdf"></i> Descargar
                </base-button>
              </div>
            </div>
            <br/>
          </div>
        </div>
      </div>
      <!--Modal Routes-->
      <CustomModal
        :is-modal="showModalInventory"
        @closeModal="showModalInventory = false"
        :closeOuth="true"
      >
        <h5 class="modal-title text semi-bold">Inventario:</h5>
        <select v-model="idInventories" :options="inventoriesFilterList" class="form-select form-control mt-2"
                aria-label="Default select example">
          <option v-for="inventories in inventoriesFilterList" :value="inventories.id">{{ inventories.externalId }}
          </option>
        </select>

        <div class="mt-4">
          <base-button
            @click="downloadInventory()"
            type="danger"
            class="btn-block"
          >
            <i class="far fa-file-pdf"></i> Descargar
          </base-button>
        </div>

      </CustomModal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip
} from "element-ui";
import CustomModal from "../../components/CustomModal.vue";
import backofficeApi from "../../gateways/backoffice-api";

export default {
  name: "starter-page",
  components: {
    CustomModal,
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      showModalInventory: false,
      loadingDownloadTheoryInventory: false,
      inventoriesFilterList: [],
      idInventories: '',
      loading_id: false,
      loadingDownloadDrinks: false,
      loadingDownloadSnacks: false,
      loadingDownload: false,
      name: "",
      user: {
        catering_id: "",
      },
      currentPage: 1,
      selectedRows: [],
      date: new Date().toISOString().substr(0, 10),
      subgroups: [],
      totalIngredients: [],
      ingredientsByMeal: [],
      meals: [],
      meals_ordered: [],
      meals_ordered_var: [],
      dates: {
        simple: "2018-07-17"
      },
      ingredients: [],
      activeDomain: false
    };
  },
  created() {
    this.getUser();
    this.getActiveDomain();
  },
  watch: {
    date: function (val) {
      this.meals = [];
      this.getIngredientsByMeal();
      this.getActiveDomain();
    }
  },
  methods: {
    downloadInventory() {
      if (this.user.catering_id == null) {
        alert('Debes seleccionar un catering')
      }
      if (this.idInventories == null) {
        alert('Debes seleccionar un inventario')
      }

      const url = `${process.env.VUE_APP_SERVICE_INVENTORIES}ingredients/${this.idInventories}`
      const options = {
        url: url,
        name: 'formato de inventario-',
        ext: ".pdf"
      }
      axios({
        url: options.url,
        method: 'get',
        responseType: 'blob',
        headers: { "Authorization": `Bearer ${window.localStorage.token_backoffice}` },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', options.name + moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + options.ext);
        document.body.appendChild(link);
        link.click();
      });

    },
    getInventories() {
      axios.get(`${process.env.VUE_APP_SERVICE_INVENTORIES}inventories/filters/inventories?cateringId=${this.user.catering_id}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.token_backoffice}`
        }})
        .then((resp) => {
          this.inventoriesFilterList = resp.data;
        });
    },
    downloadTheoryInventory() {
      if (this.date == null) {
        alert('Debes seleccionar una fecha')
      }
      if (this.user.catering_id == null) {
        alert('Debes seleccionar un Catering')
      }

      const url = `${process.env.VUE_APP_SERVICE_INVENTORIES}ingredients/outputs?date=${this.date}&cateringId=${this.user.catering_id}&name=${this.user.catering.name}`

      const options = {
        url: url,
        name: 'formato de registro de salidas-',
        ext: ".pdf"
      }
      axios({
        url: options.url,
        method: 'get',
        responseType: 'blob',
        headers: { "Authorization": `Bearer ${window.localStorage.token_backoffice}` },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', options.name + moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + options.ext);
        document.body.appendChild(link);
        link.click();
        this.loadingDownloadTheoryInventory = false
      });

    },
    /*downloadComands() {
      this.loadingDownload = true;
      axios({
        url: "/download/commands",
        method: "get",
        responseType: "blob", // important
        params: {date: moment(this.date).format("YYYY-MM-DD")}
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "comandas-" + moment(this.date).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.loadingDownload = false;
        });
    },*/
    downloadComands() {
      this.loadingDownload = true;
      backofficeApi({
        url: "download/commands",
        responseType: "blob",
        method: "get",
        params: {
          delivery_time: this.date,
          catering: this.user.catering_id,
          office: this.user.catering.branch_office_id
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "comandas-" + moment(this.date).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingDownload = false;
        });
    },
    downloadComandsSnacks() {
      this.loadingDownloadSnacks = true;
      axios({
        url: "/comandas/snacks/download/",
        method: "get",
        responseType: "blob", // important
        params: {date: moment(this.date).format("YYYY-MM-DD")}
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "cantidades-" + moment(this.date).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.loadingDownloadSnacks = false;
        });
    },
    downloadComandsDrinks() {
      this.loadingDownloadSnacks = true;
      axios({
        url: "/comandas/snacks/download/",
        method: "get",
        responseType: "blob", // important
        params: {date: moment(this.date).format("YYYY-MM-DD")}
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "cantidades-" + moment(this.date).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.loadingDownloadSnacks = false;
        });
    },
    downloadComandsMeals(date, catering_id, meal_id) {
      // this.loadingDownloadMeal = true;
      axios({
        url:
          "/final-quantities/" +
          moment(this.date).format("YYYY-MM-DD") +
          "/" +
          catering_id +
          "/" +
          meal_id,
        method: "get",
        responseType: "blob" // important
      })
        .then(response => {
          const url = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "cantidades-" +
            moment(this.date).format("YYYY-MM-DD") +
            ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          // this.loadingDownload = false;
        });
    },
    getUser() {
      axios.get("auth/me").then(resp => {
        this.user = resp.data;
        console.log(this.user);
        this.getIngredientsByMeal(this.date);
        this.getInventories()
      });
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    getActiveDomain() {
      this.loadingDownloadSnacks = true;
      this.loadingDownload = true;
      let date = moment(this.date).format("YYYY-MM-DD");
      axios
        .get("/active-download-report", {
          params: {
            date
          }
        })
        .then(response => {
          this.activeDomain = response.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingDownloadSnacks = false;
          this.loadingDownload = false;
        });
    },
    getIngredientsByMeal(date1 = null) {
      axios
        .get("subgroup/catering/meal/" + this.date)
        .then(resp => {
          this.meals = resp.data.meals;
          this.meals_ordered = resp.data.meals_ordered;
          this.meals_ordered_var = resp.data.meals_ordered_var;
          this.subgroups = resp.data.subgroup;
        })
        .catch(err => console.log(err));
    }
  }
};
</script>
<style>
.noMargin {
  margin-bottom: 0rem;
}
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
